import { Badge } from './Badge'
import { ZUSTAND_SYMBOL, ZUSTAND_TON } from '../lib/geldtueteAnzeige'
import type { TransportZustand } from '../lib/geldtuete'

/**
 * The state chip of a Geldtüte (M27 Geldtüte-Transport, prototype v44 .tt-chip): icon + word, one colour per state, the same in the Schulportal,
 * the courier page and the Büro. The word comes from the caller (each portal has its own language source). Status pill = Badge (DESIGN.md §8c).
 */
export function TransportChip({ zustand, label }: { zustand: TransportZustand; label: string }) {
  return (
    <Badge tone={ZUSTAND_TON[zustand]} size="md">
      <span className="material-symbols-outlined mr-1 !text-[15px] leading-none" aria-hidden="true">{ZUSTAND_SYMBOL[zustand]}</span>
      {label}
    </Badge>
  )
}
